<template>
    <div>
        <label class="custom-checkbox" @click="handleChange">
        <span class="checkbox" :class="{ checked: checked }">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img"
                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-check fa-w-16 fa-5x"><path
                fill="currentColor"
                d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                class=""></path></svg>
        </span>
        <span class="heading" v-text="label"></span>
        <img v-if="toolTip" :src="getImage('question-icon.svg')" alt="" @click.stop="openPopup">
        </label>
        <InputField v-if="checked" v-model="inputValue" label="Testen op" type="number" suffix="bar" :horizontal="true" />
    </div>
</template>

<script>
import NumberInput from "@/components/input/NumberInput.vue";
import InputField from "@/components/hose/components/InputField.vue";
import tooltipMixin from "@/mixins/tooltipMixin";

export default {
  name: "ToggleInput",
  components: {
      InputField,
      NumberInput
  },
  mixins: [tooltipMixin],
  props: {
    value: {
      default: () => null,
    },
    label: {
      type: String
    },
  },
  data () {
    return {
      checked: false,
    }
  },
  methods: {
    handleChange() {
      this.checked = !this.checked;
      this.$emit('toggle', this.checked);

      if (!this.checked) {
        this.$emit('change', null);
      }
    },
    openPopup() {
      this.$store.commit('tooltips/setCurrentActive', this.toolTip);
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('change', value);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-checkbox {
  display: flex;
  user-select: none;
  cursor: pointer;

  .checkbox {
    display: block;
    width: 17px;
    height: 17px;
    border: 2px solid #707070;
    border-radius: 3px;
    padding: 1px;

    svg {
      display: block;
      opacity: 0;
      transition: all ease 0.3s;
    }

    &.checked {
      border-color: black;

      svg {
        opacity: 1;
      }
    }
  }

  .heading {
    font-family: neue-haas-grotesk-display, sans-serif;
    font-weight: 700;
    font-size: 14px;
    display: flex;
    padding-left: 6px;
    margin-bottom: 0;
    margin-right: 8px;
  }
}

.input-group {
    margin-top: 6px;
    margin-bottom: 13px;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
    min-width: 100px;

    input {
        border-radius: 50px;
        min-height: 40px;
        border: 2px solid #EBEBEB;
        font-size: 12px;
        outline: none;
        box-shadow: none;
        font-family: neue-haas-grotesk-text, sans-serif;
        flex-grow: 1;

        &.error {
            color: #cc0000;
        }
    }

    span.error {
        position: absolute;
        top: 45px;
        color: #cc0000;
        font-size: 10px;
        font-style: italic;
    }

    .input-group-text {
        background-color: #EBEBEB;
        max-width: 50px;
        text-align: center;
        border-radius: 0 50px 50px 0;
        border: none;
        font-size: 12px;
        font-family: neue-haas-grotesk-text, sans-serif;

        @media only screen and (max-width: 360px) {
            min-width: 20px;
        }
    }
}
</style>
